export var TextureDecodeFormat;
(function (TextureDecodeFormat) {
    TextureDecodeFormat[TextureDecodeFormat["Normal"] = 0] = "Normal";
    TextureDecodeFormat[TextureDecodeFormat["RGBM"] = 1] = "RGBM";
})(TextureDecodeFormat || (TextureDecodeFormat = {}));
